import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  CircularProgress,
  Grid,
  Button,
  Box,
  Typography,
  Divider,
  IconButton,
  InputAdornment,
  Link
} from '@mui/material'
import { connect } from 'react-redux'
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import PersonPinCircleOutlinedIcon from '@mui/icons-material/PersonPinCircleOutlined';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { authActions, usuarioAction, empresaOrgaoAction } from '../../_actions'
import packageInfo from '../../../package.json';
import { history, stringUtils } from '../../utils'
import { withStyles } from '@mui/styles'
import { withRouter } from 'react-router-dom'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import ModalRequestPasswordReset from './ModalRequestPasswordReset'
import background from "../../img/login_mini.jpg";
import logo from "../../img/raiar.png";
import logoWhite from "../../img/raiarWhite.png";
import ModalChooseEmpresaOrgao from './ModalChooseEmpresaOrgao';
import ModalChooseTipoEmpresa from './ModalChooseTipoEmpresa';

// azul da marca (logo)
const brandBlue = '#015192'
const brandBlueDark = '#013a69'

const styles = (theme) => ({
  root: {
    minHeight: '100vh',
    width: 'auto!important',
    margin: '-8px',
    backgroundColor: '#f4f6f9'
  },
  hero: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(6, 7),
    color: '#fff',
    backgroundImage: `linear-gradient(135deg, rgba(1, 40, 80, 0.94) 0%, rgba(1, 81, 146, 0.80) 100%), url(${background})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  heroLogo: {
    display: 'block',
    width: 200,
    height: 'auto',
    objectFit: 'contain'
  },
  heroTitle: {
    fontSize: 38,
    fontWeight: 700,
    lineHeight: 1.2,
    color: '#fff',
    maxWidth: 520
  },
  heroSubtitle: {
    marginTop: theme.spacing(2),
    fontSize: 17,
    lineHeight: 1.6,
    color: 'rgba(255, 255, 255, 0.85)',
    maxWidth: 480
  },
  heroFooter: {
    fontSize: 13,
    color: 'rgba(255, 255, 255, 0.7)'
  },
  formSide: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4, 3),
    backgroundColor: '#fff',
    [theme.breakpoints.down('md')]: {
      // em telas pequenas a imagem fica ao fundo e o formulário em um cartão
      backgroundImage: `linear-gradient(135deg, rgba(1, 40, 80, 0.94) 0%, rgba(1, 81, 146, 0.80) 100%), url(${background})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }
  },
  card: {
    width: '100%',
    maxWidth: 420,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      backgroundColor: '#fff',
      borderRadius: 16,
      padding: theme.spacing(4, 3),
      boxShadow: '0 12px 40px rgba(0, 0, 0, 0.25)'
    }
  },
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: theme.spacing(3)
  },
  logo: {
    display: 'block',
    width: 240,
    maxWidth: '80%',
    height: 'auto',
    objectFit: 'contain'
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: '#1a1a1a',
    alignSelf: 'flex-start'
  },
  subtitle: {
    fontSize: 15,
    color: '#6b7280',
    alignSelf: 'flex-start',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1)
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    '& .MuiOutlinedInput-root': {
      borderRadius: 10,
      backgroundColor: '#fafbfc',
      '&.Mui-focused fieldset': {
        borderColor: brandBlue
      }
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: brandBlue
    }
  },
  inputIcon: {
    color: '#9ca3af'
  },
  forgotPassword: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(0.5)
  },
  forgotPasswordLink: {
    color: `${brandBlue}!important`,
    fontWeight: '600!important',
    fontSize: '14px!important'
  },
  submit: {
    margin: theme.spacing(3, 0, 1) + '!important',
    height: 48,
    borderRadius: '10px!important',
    fontSize: '16px!important',
    fontWeight: '600!important',
    textTransform: 'none!important',
    backgroundColor: `${brandBlue}!important`,
    boxShadow: '0 6px 16px rgba(1, 81, 146, 0.30)!important',
    '&:hover': {
      backgroundColor: `${brandBlueDark}!important`
    },
    '&.Mui-disabled': {
      color: '#fff!important',
      opacity: 0.8
    }
  },
  divider: {
    width: '100%',
    margin: theme.spacing(2.5, 0) + '!important',
    color: '#9ca3af',
    fontSize: 13
  },
  secondaryButton: {
    height: 46,
    borderRadius: '10px!important',
    textTransform: 'none!important',
    fontSize: '15px!important',
    fontWeight: '600!important',
    color: '#1a1a1a!important',
    borderColor: '#d1d5db!important',
    '&:hover': {
      borderColor: `${brandBlue}!important`,
      color: `${brandBlue}!important`,
      backgroundColor: 'rgba(1, 81, 146, 0.04)!important'
    }
  }
})

function Copyright() {
  return (
    <>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Desenvolvido por © '}
        <Link color="inherit" href="https://fortalezatec.com.br/">
          FortalezaTec
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center">
        Versão do sistema: {packageInfo.version}
      </Typography>
    </>
  )
}

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      senha: '',
      showPassword: false,
      submitted: false
    }
  }

  componentDidMount() {
    if (localStorage.getItem('auth')) {
      history.push('/dashboard')
    }
  }
  handleChange = (prop) => (event) => {
    if (prop === 'email') {
      this.setState({ [prop]: event.target.value.toLowerCase() })
    } else {
      this.setState({ [prop]: event.target.value })
    }
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { email, senha } = this.state
    const { dispatch } = this.props

    if (email && senha) {
      dispatch(authActions.login(email, senha))
    }
  }

  handleClickopenModalRequestPasswordReset = () => {
    const { dispatch } = this.props
    dispatch(usuarioAction.openModalRequestPasswordReset(true))
  }

  handleClickopenModalCadastroEmpresaOrgao = () => {
    const { dispatch } = this.props
    dispatch(empresaOrgaoAction.openModalCadastroEmpresaOrgao(true))
  }

  render() {
    const { loggingIn } = this.props
    const { classes } = this.props
    return (
      <Grid container className={classes.root}>
        <ModalRequestPasswordReset currentEmail={this.state.email} />
        <ModalChooseEmpresaOrgao />
        <ModalChooseTipoEmpresa />
        <Grid item md={7} className={classes.hero}>
          <Box sx={{ flexShrink: 0 }}>
            <img src={logoWhite} className={classes.heroLogo} alt="Raiar" />
            <Typography className={classes.heroTitle} sx={{ mt: 5 }}>
              Gestão de obras públicas, do orçamento à entrega.
            </Typography>
            <Typography className={classes.heroSubtitle}>
              Acompanhe etapas, medições, empenhos e a execução de cada obra em um só lugar.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={5} className={classes.formSide}>
          <div className={classes.card}>
            <div className={classes.logoWrapper}>
              <img src={logo} className={classes.logo} alt="Raiar Construtora On-line" />
            </div>
            <Typography className={classes.title}>Bem-vindo(a)!</Typography>
            <Typography className={classes.subtitle}>
              Informe seus dados para acessar o sistema.
            </Typography>
            <ValidatorForm
              className={classes.form}
              ref="form"
              onSubmit={this.handleSubmit}
            >
              <TextValidator
                variant="outlined"
                margin="normal"
                fullWidth
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MailOutlineRoundedIcon className={classes.inputIcon} />
                    </InputAdornment>
                  )
                }}
                label="E-mail *"
                placeholder="seuemail@exemplo.com"
                value={this.state.email}
                onInput={stringUtils.toInputLowerCase}
                onChange={this.handleChange('email')}
                id="email"
                name="email"
                autoComplete="email"
                validators={['required', 'isEmail']}
                errorMessages={[
                  'Você precisa informar o e-mail',
                  'E-mail inválido'
                ]}
              />
              <TextValidator
                variant="outlined"
                margin="normal"
                fullWidth
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockOutlinedIcon className={classes.inputIcon} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={this.state.showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                        title={this.state.showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                        onClick={this.handleClickShowPassword}
                        onMouseDown={(event) => event.preventDefault()}
                        edge="end"
                      >
                        {this.state.showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                value={this.state.senha}
                onChange={this.handleChange('senha')}
                name="senha"
                label="Senha *"
                placeholder="Digite sua senha"
                type={this.state.showPassword ? 'text' : 'password'}
                id="senha"
                autoComplete="current-password"
                validators={['required']}
                errorMessages={['Opss! Você esqueceu da senha.']}
              />
              <div className={classes.forgotPassword}>
                <Link
                  component="button"
                  type="button"
                  underline="hover"
                  onClick={this.handleClickopenModalRequestPasswordReset}
                  className={classes.forgotPasswordLink}
                >
                  {'Esqueceu a senha?'}
                </Link>
              </div>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                disabled={loggingIn}
                type="submit"
                className={classes.submit}
                startIcon={!loggingIn && <LockOpenIcon />}
                endIcon={loggingIn && <CircularProgress size={22} style={{ color: '#fff' }} />}
              >
                {loggingIn ? 'Validando informações... ' : 'Entrar'}
              </Button>
            </ValidatorForm>
            <Divider className={classes.divider}>ou</Divider>
            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={this.handleClickopenModalCadastroEmpresaOrgao}
                  type="button"
                  className={classes.secondaryButton}
                  startIcon={<AddCircleOutlineRoundedIcon />}
                >
                  {'Quero me cadastrar'}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={handleOpenPublicMap}
                  type="button"
                  className={classes.secondaryButton}
                  startIcon={<PersonPinCircleOutlinedIcon />}
                >
                  {'Mapa público de obras'}
                </Button>
              </Grid>
            </Grid>
            <Box mt={4}>
              <Copyright />
            </Box>
          </div>
        </Grid>
      </Grid>
    )
  }
}
Login.propTypes = {
  classes: PropTypes.object.isRequired
}

const handleOpenPublicMap = () => {
  history.push(`/mapa-publico/`);
}

const mapStateToProps = (state) => {
  const { loggingIn } = state.authentication
  return {
    loggingIn
  }
}
const connectedLoginPage = withRouter(
  //connect(mapStateToProps, null, null, {
  //  pure: false
  //})(withStyles(styles)(Login))
  connect(mapStateToProps, null, null)(withStyles(styles)(Login))
)
export { connectedLoginPage as Login }
